import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, shareReplay } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { GenericMasterModel } from '../../../models/maestros/generic.master.model';

@Injectable({
  providedIn: 'root',
})
export class MetodosPagoService {
  private readonly apiUrl = environment.apiUrl;
  private readonly endpoint = `${this.apiUrl}/maestras/metodo-pago`;

  private metodosPagoVigor?: Observable<GenericMasterModel[]>;
  private metodosPagoTodos?: Observable<GenericMasterModel[]>;

  constructor(private readonly http: HttpClient) {}

  getMetodosPagoVigor(): Observable<GenericMasterModel[]> {
    if (!this.metodosPagoVigor) {
      this.metodosPagoVigor = this.http.get<GenericMasterModel[]>(this.endpoint).pipe(
        shareReplay(1),
        catchError((error) => {
          console.error('MetodosPagoService - Error fetching data:', error);
          throw error;
        })
      );
    }
    return this.metodosPagoVigor;
  }

  getMetodosPagoTodos(): Observable<GenericMasterModel[]> {
    if (!this.metodosPagoTodos) {
      this.metodosPagoTodos = this.http.get<GenericMasterModel[]>(this.endpoint.concat('/todos')).pipe(
        shareReplay(1),
        catchError((error) => {
          console.error('MetodosPagoService - Error fetching data:', error);
          throw error;
        })
      );
    }
    return this.metodosPagoTodos;
  }

  setComboMetodosPago(metodosPago: GenericMasterModel[]): void {
    this.getMetodosPagoVigor().subscribe({
      next: (data) => {
        metodosPago.push(...data);
      },
      error: (error) => {
        console.error('MetodosPagoService - Error fetching data:', error);
      },
    });
  }
}
